import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  color: theme.palette.common.white,
  padding: theme.spacing(22.875, 0),
  position: 'relative',
  '& .FBGImage': {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    objectFit: 'cover',
    zIndex: -1,
    width: '100%',
    height: '100%',
  },
  '& .FContainer': {
    padding: theme.spacing(0, 3),
  },
}));

export default StyledBox;
